import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <Navigation />

      <section className="bg-sand text-indigoDeep pt-20 pb-8">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-6">
            <h1 className="font-serif text-4xl mb-4">Contact</h1>
            <p className="text-grayWarm max-w-3xl mx-auto">This is a placeholder contact page. Add contact form or contact details here.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
